export default __webpack_public_path__ + "d1bfaae871e6b3f5252d112c4eeeab57.svg";